export default __webpack_public_path__ + "static/media/topbar-icon-profile.531e8d58.svg";